// src/shared/components/ui/ThemeToggle.jsx
// ✅ زر تبديل Light / Dark — يُوضع في app-header
import React from 'react';
import useTheme from '../../hooks/useTheme';
import styles from './ThemeToggle.module.css';

const ThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      className={`${styles.toggle} ${isDark ? styles.dark : styles.light}`}
      onClick={toggleTheme}
      aria-label={isDark ? 'تفعيل الوضع الفاتح' : 'تفعيل الوضع الداكن'}
      title={isDark ? 'وضع فاتح' : 'وضع داكن'}
      type="button"
    >
      <span className={styles.track} aria-hidden="true">
        <span className={styles.thumb}>
          {isDark ? '🌙' : '☀️'}
        </span>
      </span>
    </button>
  );
};

export default ThemeToggle;